import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Shell } from "@/components/Shell";

/**
 * Where a broken OIDC exchange lands. Distinct from the unknown-account page on purpose: this
 * one means the flow itself did not finish - usually a stale tab or a back button - and trying
 * again fixes it, which is not true of not being koppeld.
 */
export function SignInFailed() {
  const { t } = useTranslation("account");

  return (
    <Shell>
      <Card>
        <CardHeader>
          <CardTitle>{t("signInFailed.title")}</CardTitle>
          <CardDescription>{t("signInFailed.description")}</CardDescription>
        </CardHeader>
        <CardContent className="text-sm">
          <a className="jb-link" href="/">
            {t("signInFailed.retry")}
          </a>
        </CardContent>
      </Card>
    </Shell>
  );
}
